import { ReactNode } from 'react';
import { useProjectSSEUpdates } from 'src/hooks/query/projectHooks';

export function ProjectSSEProvider({ children }: { children: ReactNode }) {
  useProjectSSEUpdates();

  return <>{children}</>;
}
